import React from "react"
import Content from "../../particles/Content"
import StyledMCRow from "./MultiColumnRow.style"
import { GatsbyImage } from "gatsby-plugin-image";
import { randomID } from "../../particles/helpers"
import { Link } from "gatsby"
import { useVendorData } from "../../particles/hooks/useVendorData"

const MultiColumnRow = props => {
  const { MultiColumnRow, branch, image } = props

  const vendors = useVendorData()

  return (
    <StyledMCRow image={image ? true : undefined}>
      <Content>
        <h3>
          {branch ? (
            <>
              {branch}
              <br />
            </>
          ) : null}

          {MultiColumnRow.title}
        </h3>
        <section>
          {MultiColumnRow.columns.map((column, idx) => {
            let columnVendor = null
            vendors.forEach(vendor => {
              if (
                vendor.node.VendorInfo.logo.sourceUrl === column.icon.sourceUrl
              ) {
                columnVendor = vendor
              }
            })
            const heading = column.icon ? (
              columnVendor ? (
                <a
                  href={columnVendor.node.VendorInfo.externalUrl}
                  target="_blank"
                  rel="nofollow"
                  className="vendor-logo-link"
                >
                  <GatsbyImage
                    alt={column.icon.altText}
                    image={column.icon.localFile.childImageSharp.gatsbyImageData}
                    objectFit="contain"
                    style={{
                      maxHeight: `120px`,
                      maxWidth: `400px`,
                      margin: `auto`,
                    }} />
                </a>
              ) : (
                <GatsbyImage
                  alt={column.icon.altText}
                  image={column.icon.localFile.childImageSharp.gatsbyImageData}
                  objectFit="contain"
                  style={{
                    maxHeight: `120px`,
                    maxWidth: `400px`,
                    margin: `auto`,
                  }} />
              )
            ) : (
              <>
                {column.linkTo ? (
                  <Link to={column.linkTo} state={column.linkState || null}>
                    <h4 style={{ marginTop: `1rem` }}>{column.heading}</h4>
                  </Link>
                ) : (
                  <h4 style={{ marginTop: `1rem` }}>{column.heading}</h4>
                )}
              </>
            )

            return (
              <article style={{ gridColumn: idx + 1 }} key={randomID()}>
                {heading}
                {column.text_area ? (
                  <p className={column.noLine ? `no-line` : undefined}>
                    {column.text_area}
                  </p>
                ) : null}
              </article>
            )
          })}
        </section>
      </Content>
    </StyledMCRow>
  );
}

export default MultiColumnRow
